import { render } from "./LoadingSpinner.vue?vue&type=template&id=768123c4&scoped=true&ts=true"
import script from "./LoadingSpinner.ts?vue&type=script&lang=ts"
export * from "./LoadingSpinner.ts?vue&type=script&lang=ts"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=768123c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768123c4"]])

export default __exports__